/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import {
    func, object, string, shape, bool,
} from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import { Button, IconButton } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';

import { deepObjectExtend } from '../../../utils/object';
import { main as mainStyle } from '../../../style/main';

import cancelModalIcon from '../Images/skipIcon.png';

const styles = ({ typography, palette }) => deepObjectExtend(mainStyle(typography, palette), {
    recipientDialogRoot: {
        width: '100%',
        boxSizing: 'border-box',
        alignItems: 'normal',
        height: '100%',
    },
    recipientDialogPaper: {
        boxSizing: 'border-box',
        borderRadius: '0',
        margin: '0 19.5px',
        boxShadow: '0px 0px 20px 6px rgba(0,0,0,0.5)',
        height: '100%',
        width: '100%',
        maxWidth: '454px',
        overflowY: 'auto',
        maxHeight: '673px',
        '@media screen and (min-width: 768px)': {
            maxHeight: '560px',
        },
    },
    closeIconLabel: {
        flexDirection: 'column',
        alignItems: 'flex-end',
    },
    cancelCartImg: {
        width: '134px',
        height: '108px',
        alignSelf: 'center',
        margin: '74px 120px 50px 121px',
    },
    contentContainer: {
        padding: '0 40px',
        fontSize: '18px',
        lineHeight: '28px',
        letterSpacing: '1px',
        textAlign: 'center',
    },
    marginBotton20: {
        marginBottom: '20px',
    },
    secondaryButtonStyle: {
        backgroundColor: 'transparent',
        color: palette.black,
        fontSize: '14px',
        fontWeight: 'bold',
        padding: '8px 16px',
        borderRadius: '30px',
        border: `1px solid ${palette.black}`,
        width: '48%',
        boxShadow: '2px 2px 4px rgba(47, 47, 47, 0.15)',
    },
    primaryButtonStyle: {
        color: palette.white,
        backgroundColor: palette.primaryButton,
        fontSize: '14px',
        fontWeight: 'bold',
        padding: '8px 16px',
        borderRadius: '30px',
        border: `1px solid ${palette.primaryButton}`,
        boxShadow: '2px 2px 4px rgba(47, 47, 47, 0.15)',
        width: '48%',
        '&:hover': {
            backgroundColor: '#80061a',
            color: palette.white,
        },
    },
    btnContainer: {
        height: '200px',
        position: 'relative',
        marginTop: '80px',
    },
    btnSubContainer: {
        position: 'absolute',
        marginBottom: '22px',
        padding: '0 20px',
        bottom: 0,
        left: 0,
        width: '100%',
        display: 'flex',
        justifyContent: 'space-between',
    },
    xContainer: {
        width: '50px',
        position: 'absolute',
        top: '3px',
        right: '0px',
    },
});

function SkipSubsriptionDialog({
    openModal, classes, handleSkipModal, subscription, selectedSubscription, handleUpdate,
}) {
    if (subscription.ruleId !== selectedSubscription) return null;
    return (
        <Dialog
            data-testid="subscription-recipient-form-modal"
            open={openModal}
            onClose={() => handleSkipModal(false, subscription.ruleId, 'close')}
            classes={{
                root: classes.recipientDialogRoot,
                paper: classes.recipientDialogPaper,
            }}
        >
            <div className={classes.xContainer}>
                <IconButton
                    aria-label="delete"
                    align="right"
                    data-test="checkout-recipient-form-close"
                    data-testid="checkout-recipient-form-close"
                    id="recipientFormCloseLink"
                    classes={{
                        label: classes.closeIconLabel,
                    }}
                    onClick={() => handleSkipModal(false, subscription.ruleId, 'close')}
                >
                    <CloseIcon fontSize="small" />
                </IconButton>
            </div>
            <img src={cancelModalIcon} className={classes.cancelCartImg} alt="fireSpot" />
            <div className={classes.contentContainer}>
                <div className={classes.marginBotton20}>Are you sure you&apos;d like to SKIP your next delivery?</div>
            </div>
            <div className={classes.btnContainer}>
                <div className={classes.btnSubContainer}>
                    <Button onClick={() => handleUpdate('skip', subscription.ruleId, 'Yes')} className={classes.secondaryButtonStyle}>YES</Button>
                    <Button onClick={() => handleSkipModal(false, subscription.ruleId, 'No')} className={classes.primaryButtonStyle}>NO</Button>
                </div>
            </div>
        </Dialog>
    );
}

SkipSubsriptionDialog.propTypes = {
    classes: object.isRequired,
    subscription: shape({
        productId: string,
    }),
    handleSkipModal: func.isRequired,
    openModal: bool.isRequired,
    handleUpdate: func.isRequired,
    selectedSubscription: string.isRequired,
};
SkipSubsriptionDialog.defaultProps = {
    subscription: {},
};
export default withStyles(styles, { withTheme: true })(SkipSubsriptionDialog);
